import { Link } from '@mui/material';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import ListItemText from '@mui/material/ListItemText';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { fAPIDate } from 'src/utils/format-time';
import { fCurrencyRupees } from 'src/utils/format-number';
import { getFactoringStatusColor } from 'src/utils/cheque-factoring-helpers';

import Label from 'src/components/label';

import { IChequeListItem } from 'src/types/cheque';

type Props = {
  row: IChequeListItem;
};

// Read-only row — this is a batch's cheque manifest, not the editable cheque
// list, so there's no edit/delete action here (those live on the cheque's
// own detail page, linked below).
export default function BatchChequeTableRow({ row }: Props) {
  const { _id, chequeNumber, customer, bank, chequeDate, amountInCents, factoringStatus } = row;

  return (
    <Link
      component={RouterLink}
      href={paths.dashboard.cheque.view(_id)}
      sx={{ textDecoration: 'none', color: 'inherit', display: 'contents' }}
    >
      <TableRow hover>
        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
          <ListItemText
            primary={bank}
            secondary={chequeNumber}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{
              component: 'span',
              color: 'text.disabled',
              typography: 'caption',
            }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{customer}</TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
          {fAPIDate(chequeDate)}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          {fCurrencyRupees(amountInCents)}
        </TableCell>

        <TableCell sx={{ textAlign: 'left' }}>
          <Label variant="soft" color={getFactoringStatusColor(factoringStatus)}>
            {factoringStatus}
          </Label>
        </TableCell>
      </TableRow>
    </Link>
  );
}
